import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router, Params, NavigationExtras } from '@angular/router';
import { BlastMsg, BlastCredit, BlastUsage } from 'src/app/interfaces/blast';

import { BlastCreditService } from 'src/app/services/blast/blast-credit.service';
import { LinkService } from 'src/app/services/general/link.service';
import { BlastResultType } from 'src/app/types/blast';

@Component({
  selector: 'app-blast-result',
  templateUrl: './blast-result.page.html',
  styleUrls: ['./blast-result.page.scss'],
})
export class BlastResultPage implements OnInit, OnDestroy {

  ready: boolean;
  type: BlastResultType;
  blastMsgList: BlastMsg[];
  blastUsage: BlastUsage;

  blastCreditIdList: string[];

  count: number;
  
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private blastCreditService: BlastCreditService,
    private linkService: LinkService,
  ) { }

  ngOnInit() {
    this.watchRoute();
  }

  ngOnDestroy(): void {
      
  }

  ionViewWillEnter() {

  }

  ionViewDidLeave() {
    this.ready = false;
  }

  watchRoute() {
    this.route.params.subscribe((param: Params) => {
      const route = this.router.getCurrentNavigation();
      const state = route?.extras?.state;

      if (state?.blastMsgList) {
        this.blastMsgList = state.blastMsgList;
      } else if (param?.blastMsgList) {
        this.blastMsgList = param?.blastMsgList;
      } else {
        this.blastMsgList = [];
      }

      if (state?.blastUsage) {
        this.blastUsage = state.blastUsage;
      } else if (param?.blastUsage) {
        this.blastUsage = param?.blastMsgUsage;
      } else {
        this.blastUsage = null;
      }

      if (state?.blastCreditIdList?.length) {
        this.blastCreditIdList = state.blastCreditIdList;
      } else if (param?.blastCreditIdList?.length) {
        this.blastCreditIdList = param?.blastCreditIdList;
      } else {
        this.blastCreditIdList = [];
      }
      
      this.checkResult();
    });
  }

  checkResult() {
    if (this.blastUsage?.usageId && this.blastMsgList?.length) {
      this.type = 'sent';
      this.count = this.getCount();
    } else if (this.blastCreditIdList?.length) {
      this.type = 'package';
      this.count = this.getCount();
    } else {
      this.linkService.goMainPage();
    }
    this.ready = true;
  }

  getCount() {
    if (this.type === 'sent' && this.blastMsgList?.length) {
      return this.blastMsgList?.length;
    } else if (this.type === 'package' && this.blastCreditIdList?.length) {
      return this.calculateBlastCredit();
    }
    return 0;
  }

  calculateBlastCredit() {
    const blastCreditList = this.blastCreditService.getBlastCreditListById(this.blastCreditIdList);
    return blastCreditList?.reduce((a: number, b: BlastCredit) => {
      return a + (b?.blastCredit ? b?.blastCredit : 0);
    }, 0)
  }

  back() {
    
  }

  goBlastHomePage() {
    this.router.navigate(['/blast/home'], { replaceUrl: true });
  }

}
